import React from 'react';

import Box, { BoxProps } from '@mui/material/Box';

type FlexContainerProps = Omit<BoxProps, 'component'> & {
  direction?: 'row' | 'column';
  scroll?: 'auto' | 'hidden' | 'visible';
  component?: React.ElementType;
};

const FlexContainer = ({
  direction = 'row',
  scroll,
  component = Box,
  sx,
  ...rest
}: FlexContainerProps) => {
  return (
    <Box
      component={component}
      sx={{
        display: 'flex',
        flex: 1,
        minHeight: 0,
        flexDirection: direction,
        overflow: scroll,
        ...sx,
      }}
      {...rest}
    />
  );
};

export default FlexContainer;
